import { BarChart3 } from 'lucide-react'
import { useTranslation } from '@/hooks/use-translation'

type ContentStatsResult = {
  total: number
  byStatus: Record<string, number>
}

type Props = {
  result: ContentStatsResult | null | undefined
}

export function ContentStatsCard({ result }: Props) {
  const t = useTranslation()

  if (!result || !result.byStatus) return null

  if (result.total === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-3 my-1.5 text-muted-foreground text-sm">
        {t('agent.tools.contentStats.empty')}
      </div>
    )
  }

  return (
    <div className="bg-card border border-border rounded-xl p-3 my-1.5">
      <div className="flex items-center gap-2 mb-2">
        <BarChart3 className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium text-card-foreground">{t('agent.tools.contentStats.title')}</span>
      </div>
      <div className="text-2xl font-semibold text-card-foreground mb-2">{t('agent.tools.contentStats.total', { count: result.total })}</div>
      <div className="grid grid-cols-3 gap-2">
        {Object.entries(result.byStatus).map(([status, count]) => (
          <div key={status} className="flex flex-col items-center rounded-lg bg-muted/40 px-2 py-1.5">
            <span className="text-xs text-muted-foreground capitalize">{status}</span>
            <span className="text-sm font-medium text-card-foreground">{count}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
